import { discoverMockNetwork } from "../mockDiscovery";

/**
 * DiscoveryService — CAN bus network scan.
 * Swap this singleton for a real BLE-CAN adapter when hardware support is available.
 * Real implementation must satisfy: { discover() → { nodes, devices } }.
 */
export const DiscoveryService = {
  /** @returns {{ nodes: object[], devices: object[] }} */
  discover: () => discoverMockNetwork(),
};
